import {
  Component,
  computed,
  EventEmitter,
  input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { faCalendarDay, faCaretDown } from '@fortawesome/pro-regular-svg-icons';
import { OConfigService } from '@olameter/o-config-service';
import { Subscription } from 'rxjs';
import { WorkorderGRPCService } from '../../../ProxyServices/workorder.grpc.service';
import { WOStatusWeb } from '../../../constants/woStatusOptions';
import { ViewResponseModel } from 'src/app/CommonFiles/BusinessModels';

@Component({
  standalone: false,
  selector: 'app-blackout',
  templateUrl: './blackout.component.html',
  styleUrls: ['./blackout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlackoutComponent {
  faCalendarDay = faCalendarDay;
  faCaretDown = faCaretDown;
  subscriptions: Subscription[] = [];

  @Output() completedEvent: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();

  readOnlyMode = input<boolean>(false);
  active = input<ViewResponseModel>(null);
  selectedWOstatus = input<string[]>([]);
  isPlannedInstalledDateDisabled = computed<boolean>(() => {
    const selectedWOStatus = this.selectedWOstatus();
    let disableButton = !!(selectedWOStatus.length === 0);
    if (selectedWOStatus.length > 0) {
      disableButton = selectedWOStatus.every(
        (x) => x === WOStatusWeb.Completed || x === WOStatusWeb.ReturnToUtility
      );
    }
    return disableButton;
  });

  public showBlackoutWarning: boolean = false;
  public showInstallDate: boolean = false;

  constructor(
    public _clientWO: WorkorderGRPCService,
    private config: OConfigService
  ) {}

  onPlannedInstallDateClick() {
    const selectionOnGrid = this._clientWO.RXselectedWOIDsShared.value;
    this.showInstallDate = selectionOnGrid?.length > 0;
  }

  showBlackout() {
    const selectionOnGrid = this._clientWO.RXselectedWOIDsShared.value;
    if (selectionOnGrid?.length > 1 || selectionOnGrid?.length === 0) {
      this.showBlackoutWarning = true;
    } else {
      this._clientWO.getOne(selectionOnGrid[0].name).subscribe((wo) => {
        let path =
          this.config.getConfig().blackoutURL +
          '/' +
          this.active().contractName +
          '/' +
          wo.ServiceType;
        let win = window.open(path, '_blank', 'noopener');
        if (win) {
          win.focus();
        }
      });
    }
  }

  public getInstallDateSelection(): any[] {
    const selectionOnGrid = this._clientWO.RXselectedWOIDsShared.value;
    return selectionOnGrid?.map((itemOnGrid) => {
      return {
        name: itemOnGrid.name,
        contractname: this.active().contractName,
        servicetype: itemOnGrid.ServiceType,
      };
    });
  }

  public complete(e) {
    this.completedEvent.emit(e);
  }
}
